<template>
  <div class="container-fluid reports-sub-menu">
    <div class="row m-0">
      <div class="col-md-12 xs-pl-0">
        <div :class="{'hide_tabs': hideTabs}" class="heading-sub-menu">
          Reports
        </div>
      </div>
      <!-- <el-tabs
        class="col-xs-12 elTabs xs-pl-0"
        v-model="tabActiveName"
        @tab-click="handleClick"
        v-if="!hideTabs"
      >
        <el-tab-pane name="ReportSummary">
          <span slot="label">Summary</span>
        </el-tab-pane>
        <el-tab-pane name="ReportCountry">
          <span slot="label">Country</span>
        </el-tab-pane>
        <el-tab-pane name="ReportDevice">
          <span slot="label">Device</span>
        </el-tab-pane>
        <el-tab-pane name="ReportStatus">
          <span slot="label">Status</span>
        </el-tab-pane>
      </el-tabs> -->
      <div class="col-md-12 tabs-left" v-if="!hideTabs">
        <ul class="nav nav-tabs" role="tablist">
          <li role="presentation" class="nav-item" :class="{active: tabActiveName=='ReportSummary'}">
            <span class="nav-link" @click="handleClick('ReportSummary')" role="tab" data-toggle="tab">Summary</span></li>
          <li role="presentation" class="nav-item" :class="{active: tabActiveName=='ReportCountry'}">
            <span class="nav-link" @click="handleClick('ReportCountry')" role="tab" data-toggle="tab">Country</span>
          </li>
          <li role="presentation" class="nav-item" :class="{active: tabActiveName=='ReportDevice'}">
            <span class="nav-link" @click="handleClick('ReportDevice')" role="tab" data-toggle="tab">Device</span>
          </li>
          <li role="presentation" class="nav-item" :class="{active: tabActiveName=='ReportStatus'}">
            <span class="nav-link" @click="handleClick('ReportStatus')" role="tab" data-toggle="tab">Status</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import EventBus from '../../utils/event-bus';

export default {
  props: ['hideTabs', 'permissions'],
  data() {
    return {
      tabActiveName: '',
      urls: {
        ReportSummary: '/layout/report/summary',
        ReportCountry: '/layout/report/country',
        ReportDevice: '/layout/report/device',
        ReportStatus: '/layout/report/status',
      },
    };
  },
  methods: {
    handleClick(tab) {
      this.tabActiveName = tab;
      if (this.urls[tab] !== this.$route.path) {
        this.$router.push({
          name: tab,
          params: { reportPermissions: this.permissions },
        });
      }
    },
    checkRoute() {
      switch (this.$route.path) {
        case this.urls.ReportSummary:
          this.tabActiveName = 'ReportSummary';
          break;
        case this.urls.ReportCountry:
          this.tabActiveName = 'ReportCountry';
          break;
        case this.urls.ReportDevice:
          this.tabActiveName = 'ReportDevice';
          break;
        case this.urls.ReportStatus:
          this.tabActiveName = 'ReportStatus';
          break;
        default:
          this.tabActiveName = 'ReportSummary';
          break;
      }
    },
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        if (this.$route.path === this.urls.ReportSummary) {
          EventBus.$emit('permissionsSummaryList', this.permissions);
        }
        this.checkRoute();
      },
    },
    permissions() {
      if (this.$route.path === this.urls.ReportSummary) {
        EventBus.$emit('permissionsSummaryList', this.permissions);
      } else if (this.$route.path === this.urls.ReportCountry) {
        EventBus.$emit('permissionsCountryList', this.permissions);
      } else if (this.$route.path === this.urls.ReportDevice) {
        EventBus.$emit('permissionsDeviceList', this.permissions);
      }
    },
  },
  created() {
    this.checkRoute();
  },
};
</script>
<style scoped>
.reports-sub-menu {
  padding-left: 22px;
}
.heading-sub-menu {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
  padding-top: 20px;
  padding-bottom: 20px;
}

@media screen and (max-width:767px){
  .hide_tabs{
    display: none;
  }
  .xs-pl-0{
    padding-left: 0px;
  }
}
/* ul.nav-tabs::after {
  list-style-type: none;
  display: flex;
  width: 100%;
  justify-content: flex-start;
  padding-bottom: 4px;
  border-top: 1px solid #BDBDBD;
}
ul li.nav-item {
  cursor: pointer;
  position: relative;
  text-align: center;
}
li.nav-item.active::after {
  position: absolute;
  content: "";
  height: 3px;
  width: 100%;
  border-bottom: 8px solid #4c9e45;
  background: none;
  left: 0;
  bottom: -3px;
  animation: appear 0.2s linear;
}
.nav-tabs>li.active,
.nav-tabs>li.active:focus,
.nav-tabs>li.active:hover {
  color: #000000;
  cursor: pointer;
  font-weight: bold;
  border: none;
}
ul.nav-tabs > li {
  margin-right: 40px;
  padding-bottom: 10px;
  font-size: 18px;
}
@keyframes appear {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
} */
</style>
